import React, { useState } from 'react';
import { subscribeToNewsletter } from '../../../services/parse';
import { NotificationManager } from 'react-notifications';
import { gtmEvent } from '../../../services/google-tag-manager';
import './NewsletterFormWrapper.css';

export default function NewsletterForm() {
  const [emailAddress, setEmailAddress] = useState('');

  const handleChange = (event) => {
    setEmailAddress(event.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    subscribeToNewsletter({
      email: emailAddress,
      listId: parseInt(process.env.REACT_APP_ITERABLE_EMAIL_LISTID),
      source: 'foos site global footer',
    })
      .then(() => {
        NotificationManager.success('Your email has been added to our mailing list. Thank you!', '', 5000);
        setEmailAddress('');

        gtmEvent({
          action: 'newsletterSignup',
          email_address: emailAddress,
          userType: 'newsletter',
        });
      })
      .catch((error) => {
        NotificationManager.error("We're sorry, something went wrong. Please try again.", '', 50000);
      });
  };

  return (
    <form className="email-form" onSubmit={(e) => handleSubmit(e)}>
      <input type="email" name="MERGE0" id="mk_search" aria-required="true" aria-invalid="false" placeholder="Email address" value={emailAddress} onChange={handleChange} required />
      <input type="submit" value="Sign up" />
      <input type="hidden" name="MERGE3" value="Other" checked readOnly />
    </form>
  );
}



// WEBPACK FOOTER //
// ./src/components/forms/NewsletterForm/index.js